import React from 'react'
import styled, { withTheme } from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { Card as MuiCard, Box } from '@mui/material'
import { spacing } from '@mui/system'
import LogoLoader from '../../components/LogoLoader'
import { formatDecimal } from '../../services/utils/format-numbers'
import {
  TotalUserIcon,
  TotalConsumerIcon,
  TotalProducerIcon,
  TotalCapacityIcon,
} from '../../components/icons/myIcons'
import {
  BoxTypography,
  BoxData,
  IconWrapper,
  StyledBox,
  Container,
} from './styles'
import EnergyKpi from './EnergyKpis'

const Card = styled(MuiCard)(({ theme }) => ({
  ...spacing,
  backgroundColor: theme.tokens.transparentBackground,
  marginRight: 18,
}))
/**
 * This is the component to show main four KPIs on dashboard.
 * It holds all the KPIs and grpah.
 *
 * @returns {React.ReactNode} A React component that renders the KPIs and also the Bar graph.
 */
function BarChart({
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  loading,
  usersCount,
  period,
  setPeriod,
  data,
  contractStats,
}) {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      {/* Here the Card and Container components are designed to show the four main KPIs on the dashboard. */}
      <Card>
        {loading ? (
          <LogoLoader />
        ) : (
          <Container>
            <StyledBox>
              <Box>
                <BoxTypography variant="h5">{t('LBLTotalUsers')}</BoxTypography>
                <BoxData variant="h1">{usersCount}</BoxData>
              </Box>
              <IconWrapper>
                <TotalUserIcon style={{ fontSize: 44 }} />
              </IconWrapper>
            </StyledBox>

            <StyledBox>
              <Box>
                <BoxTypography variant="h5">
                  {t('LBLTotalConsumers')}
                </BoxTypography>
                <BoxData variant="h1">
                  {contractStats?.consumerContracts}
                </BoxData>
              </Box>
              <TotalConsumerIcon style={{ fontSize: 44 }} viewBox="0 0 49 49" />
            </StyledBox>

            <StyledBox>
              <Box>
                <BoxTypography variant="h5">
                  {t('LBLTotalProducers')}
                </BoxTypography>
                <BoxData variant="h1">
                  {contractStats?.producerContracts}
                </BoxData>
              </Box>
              <TotalProducerIcon style={{ fontSize: 44 }} viewBox="0 0 48 49" />
            </StyledBox>

            <StyledBox>
              <Box>
                <BoxTypography variant="h5">
                  {t('LBLTotalEnergyCapacity')}
                </BoxTypography>
                <BoxData variant="h1">
                  {formatDecimal(contractStats?.totalEnergyAmount ?? 0) + ' kW'}
                </BoxData>
              </Box>
              <TotalCapacityIcon style={{ fontSize: 44 }} viewBox="0 0 48 49" />
            </StyledBox>
          </Container>
        )}
      </Card>
      {/*Here the EnergyKpi is another component that is use to hold the data KPIs and graph on the front page of dashboard */}
      <div style={{ height: '10px' }} />
      <EnergyKpi
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        period={period}
        setPeriod={setPeriod}
        data={data}
      />
    </React.Fragment>
  )
}
export default withTheme(BarChart)
